import React from 'react';
import { Briefcase, Award, BookOpen, Heart, Download } from 'lucide-react';

const About = () => {
  const stats = [
    {
      icon: <Briefcase size={40} />,
      value: '1 Year',
      label: 'Experience'
    },
    {
      icon: <Award size={40} />,
      value: '10 Projects',
      label: 'Successfully Completed'
    },
    {
      icon: <BookOpen size={40} />,
      value: 'Continuous Learning',
      label: 'Always Improving'
    },
    {
      icon: <Heart size={40} />,
      value: 'Passion Driven',
      label: 'Love What I Do'
    }
  ];

  return (
    <section id="about" className="about-section slide-in-section">
      <div className="container">
        <div className="section-header">
          <span className="section-number">02</span>
          <h2 className="section-title">ABOUT ME</h2>
        </div>

        <div className="about-grid">
          <div className="about-content">
            <p className="about-intro">
              <span className="highlight">Hi, I'm Tejeesh Sai Reddi, a passionate Full Stack Web Developer with expertise in building modern, scalable web applications. I specialize in the MERN stack and love bringing ideas to life through clean, efficient code.</span>
            </p>
            <p className="about-text">
              <span className="highlight">My journey in web development started with a curiosity about how websites work, and it has evolved into a career I'm truly passionate about. I enjoy solving complex problems, learning new technologies, and creating user-friendly applications that make a difference.</span>
            </p>
            <p className="about-text">
              <span className="highlight">When I'm not coding, you can find me exploring new technologies, contributing to open-source projects, or sharing knowledge with the developer community. I believe in continuous learning and staying updated with the latest industry trends.</span>
            </p>
            <div className="about-cta">
              <a href="/resume.pdf" target="_blank" rel="noopener noreferrer" className="resume-download-btn">
                <Download size={20} />
                <span>Download Resume</span>
              </a>
            </div>
          </div>

          {/* Moved Profile Photo Here */}
          <div className="about-photo-container">
            <img src="/profile-large.jpg" alt="Tejeesh Sai" className="about-profile-photo" />
          </div>

          <div className="stats-grid">
            {stats.map((stat, idx) => (
              <div key={idx} className="stat-card">
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;